module.exports = __webpack_public_path__ + "img/kitkitnumber@3x.5dc6f1dc.png";